<template>
    <q-card class="border-positive text-body2 text-weight-light q-mt-md">
        <q-card-section class="bg-positive text-white q-pa-none" dir="ltr">
            <q-item clickable v-ripple class="text-h6" @click="$emit('showTiers')">
                <q-item-section>
                    <div>
                        <currency-format
                            :value="1"
                            hide-zero-decimal
                            hide-white-spaces
                            style="display:inline-block"
                            :unit="rateReversed ? destCurrency : originCurrency"
                        />
                        =
                        <currency-format
                            :value="discountedDisplayableRate"
                            hide-zero-decimal
                            hide-white-spaces
                            style="display:inline-block"
                            :unit="rateReversed ? originCurrency : destCurrency"
                        />&nbsp;<q-chip square color="green-5" text-color="white" icon="fa fa-tag">{{$t('calculator.offer')}}</q-chip>
                    </div>
                </q-item-section>
            </q-item>
        </q-card-section>

        <q-card-section>
            <p class="text-body1">{{$t('calculator.select_currency_of_discount')}}:</p>

            <q-item tag="label" class="q-pa-none q-pb-sm">
                <q-item-section avatar top>
                    <q-radio v-model="discountType" val="origin" color="positive" />
                </q-item-section>
                <q-item-section>
                    <q-item-label style="line-height: 1.5em !important" class="text-body1">
                        <i18n path="calculator.rebit_pays_x_more">
                            <template #x>
                                <currency-format
                                    :value="discountedDestAmount - destAmount"
                                    :unit="destCurrency"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block;"
                                    class="text-weight-medium"
                                />
                            </template>
                        </i18n>
                    </q-item-label>
                    <q-item-label v-if="discountType === 'origin'" class="text-grey-7">
                        <i18n path="calculator.i_pay_n_fees_recipient_gets_x">
                            <template #origin>
                                <currency-format
                                    :value="originAmount"
                                    :unit="originCurrency"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block;"
                                />
                            </template>
                            <template #dest>
                                <currency-format
                                    :value="discountedDestAmount"
                                    :unit="destCurrency"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block;"
                                />
                            </template>
                        </i18n>
                    </q-item-label>
                </q-item-section>
            </q-item>

            <q-item tag="label" class="q-pa-none">
                <q-item-section avatar top>
                    <q-radio v-model="discountType" val="destination" color="positive"/>
                </q-item-section>
                <q-item-section>
                    <q-item-label style="line-height: 1.5em !important" class="text-body1" top>
                        <i18n path="calculator.i_pay_x_symbol_less">
                            <template #x>
                                <currency-format
                                    :value="originAmount - discountedOriginAmount"
                                    :unit="originCurrency"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block;"
                                    class="text-weight-medium"
                                />
                            </template>
                        </i18n>
                    </q-item-label>
                    <q-item-label v-if="discountType === 'destination'" class="text-grey-7">
                        <i18n path="calculator.i_pay_n_fees_recipient_exactly_gets_x">
                            <template #origin>
                                <currency-format
                                    :value="discountedOriginAmount"
                                    :unit="originCurrency"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block;"
                                />
                            </template>
                            <template #plus_fees>
                                <span class="text-grey-7"> {{$t('calculator.plus_fees')}}</span>
                            </template>
                            <template #dest>
                                <currency-format
                                    :value="destAmount"
                                    :unit="destCurrency"
                                    hide-zero-decimal
                                    hide-white-spaces
                                    style="display: inline-block;"
                                />
                            </template>
                        </i18n>
                    </q-item-label>
                </q-item-section>
            </q-item>
        </q-card-section>
    </q-card>
</template>
<script>

export default {
    name: "TieredDiscount",
    model: {
        prop: 'type',
        event: 'input'
    },
    props: {
        type: {
            type: String,
            default: null
        },
        originAmount: {
            type: [String, Number],
            default: 0
        },
        rateReversed: {
            type: Boolean,
            default: false
        },
        originCurrency: {
            type: String,
            default: 'NZD'
        },
        discountedOriginAmount: {
            type: Number,
            default: 0
        },
        destAmount: {
            type: [String, Number],
            default: 0
        },
        destCurrency: {
            type: String,
            default: 'NZD'
        },
        discountedDestAmount: {
            type: Number,
            default: 0
        },
        discountedDisplayableRate: {
            type: Number,
            default: 0
        },
    },
    computed: {
        discountType: {
            get: function() {
                return this.type
            },
            set: function(value) {
                this.$emit('input', value)
            }
        },
    },
    data() {
        return {

        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
